/**
 * 缸体系列规格表 —— “推力 → 缸体系列 → 产品模型” 的映射桥。
 *
 * 背景：选型算法（@noumase/cylinder-calc）只反算“电机 + 导程 + 传动比”，
 * 输出 Recommendation 里没有缸体系列维度。本表在 selector 层补这座桥：
 * 按方案的实际推力命中对应缸体系列，从而在选型结果里展示该系列的 3D 模型 /
 * 产品照片（“按推力自动推荐系列”）。
 *
 * ⚠️ 当前为占位样例（仅 NMS35 / NMS45 两档），thrustMax 阈值待工厂提供
 *    全套缸体系列的真实推力分档后替换；modelUrl 指向（压缩后的）GLB。
 *    全套库接入后，这张表就是“填数据 + 丢文件”的扩展点。
 */

export interface CylinderSeriesSpec {
  /** 缸体系列代号，如 'NMS35' */
  series: string;
  /** 该系列额定推力上限 (KG)；按上限升序分档 */
  thrustMax: number;
  /** （压缩后）GLB 路径，public 下 */
  modelUrl: string;
  /** 产品照片路径（可选，列表缩略图用，后续补） */
  photoUrl?: string;
}

/** 样例规格表（占位阈值，待工厂确认），必须按 thrustMax 升序排列 */
export const CYLINDER_SERIES: readonly CylinderSeriesSpec[] = [
  { series: 'NMS35', thrustMax: 800, modelUrl: '/models/nms35.glb' },
  { series: 'NMS45', thrustMax: Number.POSITIVE_INFINITY, modelUrl: '/models/nms45.glb' },
];

/**
 * 按实际推力 (KG) 命中缸体系列：返回首个 thrustMax ≥ thrust 的系列。
 * 入参非法或表为空时返回 null；超过最大档位时落到最后一档（最大系列）。
 */
export function pickSeriesByThrust(thrust: number): CylinderSeriesSpec | null {
  if (!Number.isFinite(thrust) || CYLINDER_SERIES.length === 0) return null;
  for (const spec of CYLINDER_SERIES) {
    if (thrust <= spec.thrustMax) return spec;
  }
  return CYLINDER_SERIES[CYLINDER_SERIES.length - 1] ?? null;
}
